export default function TestimonialSection() {
  return (
    <section className="w-full px-6 md:px-10 py-20 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          <div className="lg:w-[60%]">
            <span className="text-xs font-semibold text-accent-600 uppercase tracking-wider flex items-center gap-2">
              <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
              Community Verified
            </span>

            <blockquote className="mt-6">
              <p className="font-heading text-2xl md:text-3xl lg:text-4xl font-medium text-foreground-950 leading-relaxed italic">
                &ldquo;I have been using Sugargoo spreadsheets for over two years now, and the difference between curated links and random browsing is night and day. Every single haul I have put together using spreadsheet links has been a success — zero disappointments, all gems.&rdquo;
              </p>
            </blockquote>

            <div className="mt-6 flex items-center gap-3">
              <span className="text-sm font-semibold text-foreground-950">Alex M.</span>
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-verified-badge-fill text-accent-500 text-sm"></i>
              </span>
              <span className="text-xs text-foreground-400">Verified Buyer</span>
            </div>
          </div>

          <div className="lg:w-[40%] flex justify-center">
            <div className="w-56 h-72 md:w-64 md:h-80 rounded-lg overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=A%20person%20sitting%20at%20a%20cafe%20table%20by%20a%20window%20looking%20at%20a%20laptop%20displaying%20a%20spreadsheet%2C%20warm%20coffee%20shop%20interior%2C%20soft%20natural%20light%2C%20candid%20lifestyle%20portrait%2C%20cozy%20atmosphere%20with%20hanging%20plants%2C%20warm%20brown%20and%20cream%20color%20tones&width=500&height=700&seq=testimonial-v2-2026&orientation=portrait"
                alt="Community verified Sugargoo spreadsheet user portrait"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}